<template>
  <div class="product-container">
    <!-- 搜索和操作区域 -->
    <div class="search-section">
      <el-card shadow="never">
        <div class="search-form">
          <el-form :model="searchForm" inline >
            <el-form-item label="产品大类">
              <el-select v-model="searchForm.type" placeholder="请选择产品大类" style="width: 200px;" clearable>
                <el-option label="电子类" value="电子类" />
                <el-option label="机械类" value="机械类" />
                <el-option label="化工类" value="化工类" />
                <el-option label="建材类" value="建材类" />
                <el-option label="其他" value="其他" />
              </el-select>
            </el-form-item>
            
        
            
            <el-form-item label="产品名称">
              <el-input v-model="searchForm.name" placeholder="请输入产品名称" clearable />
            </el-form-item>
     
            
            <el-form-item>
              <el-button type="primary" @click="handleSearch">查询</el-button>
              <el-button @click="handleReset">重置</el-button>
                  <el-button type="primary" @click="handleAdd">
            <el-icon><Plus /></el-icon>
            新增产品
          </el-button>
          <el-button @click="handleExport">
            <el-icon><Download /></el-icon>
            导出数据
          </el-button>
            </el-form-item>
          </el-form>
          
        </div>
        
     
      </el-card>
    </div>

    <!-- 表格区域 -->
    <div class="table-section">
      <el-card shadow="never">
        <el-table
          :data="tableData"
          v-loading="loading"
          border
          stripe
          style="width: 100%">
          
          <el-table-column type="index" label="序号" width="60" align="center" />
          
          <el-table-column label="产品图片" width="100" align="center">
            <template #default="{ row }">
              <el-image
                v-if="row.image"
                :src="row.image"
                :preview-src-list="[row.image]"
                fit="cover"
                style="width: 60px; height: 60px; border-radius: 4px;"
              >
                <template #error>
                  <div class="image-slot">
                    <el-icon><Picture /></el-icon>
                  </div>
                </template>
              </el-image>
              <div v-else class="no-image">
                <el-icon><Picture /></el-icon>
              </div>
            </template>
          </el-table-column>
          
          <el-table-column prop="type" label="产品大类" width="120" show-overflow-tooltip />
          
          <el-table-column prop="spa" label="产品型号" width="150" show-overflow-tooltip />
          
          <el-table-column prop="name" label="产品名称" min-width="180" show-overflow-tooltip />
          
          <el-table-column prop="brand" label="品牌" width="120" show-overflow-tooltip />
          
          <el-table-column prop="category" label="产品分类" width="120" show-overflow-tooltip />
          
          <el-table-column prop="unit" label="计量单位" width="100" align="center" />
          
          <el-table-column prop="weight" label="重量(kg)" width="100" align="center">
            <template #default="{ row }">
              {{ row.weight || '-' }}
            </template>
          </el-table-column>
          
          <el-table-column label="状态" width="100" align="center">
            <template #default="{ row }">
              <el-tag
                :type="getStatusType(row.status)"
                size="small">
                {{ getStatusText(row.status) }}
              </el-tag>
            </template>
          </el-table-column>
          
          <el-table-column prop="created_at" label="创建时间" width="160" align="center">
            <template #default="{ row }">
              {{ formatDate(row.created_at) }}
            </template>
          </el-table-column>
          
          <el-table-column prop="created_by" label="创建人" width="120" show-overflow-tooltip />
          
          <el-table-column label="操作" width="240" fixed="right" align="center">
            <template #default="{ row }">
              <el-button
                type="primary"
                size="small"
                text
                @click="handleEdit(row)">
                编辑
              </el-button>
              <el-button
                type="danger"
                size="small"
                text
                @click="handleDelete(row.id)">
                删除
              </el-button>
              <el-button
                type="warning"
                size="small"
                text
                @click="handleView(row)">
                详情
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pagination-section">
          <el-pagination
            v-model:current-page="pagination.currentPage"
            v-model:page-size="pagination.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            :total="pagination.total"
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </el-card>
    </div>

    <!-- 新增/编辑对话框 -->
    <el-dialog
      :title="dialogTitle"
      v-model="dialogVisible"
      width="800px"
      @close="handleDialogClose">
      <el-form
        ref="productFormRef"
        :model="productForm"
        :rules="productRules"
        label-width="100px">
        
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="产品大类" prop="type">
              <el-select v-model="productForm.type" placeholder="请选择产品大类" style="width: 100%">
                <el-option label="电子类" value="电子类" />
                <el-option label="机械类" value="机械类" />
                <el-option label="化工类" value="化工类" />
                <el-option label="建材类" value="建材类" />
                <el-option label="其他" value="其他" />
              </el-select>
            </el-form-item>
          </el-col>
          
          <el-col :span="12">
            <el-form-item label="产品型号" prop="spa">
              <el-input v-model="productForm.spa" placeholder="请输入产品型号" />
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="产品名称" prop="name">
              <el-input v-model="productForm.name" placeholder="请输入产品名称" />
            </el-form-item>
          </el-col>
          
          <el-col :span="12">
            <el-form-item label="品牌" prop="brand">
              <el-input v-model="productForm.brand" placeholder="请输入品牌名称" />
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="产品分类" prop="category">
              <el-input v-model="productForm.category" placeholder="请输入产品分类" />
            </el-form-item>
          </el-col>
          
          <el-col :span="12">
            <el-form-item label="子分类" prop="sub_category">
              <el-input v-model="productForm.sub_category" placeholder="请输入产品子分类" />
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="计量单位" prop="unit">
              <el-select v-model="productForm.unit" placeholder="请选择计量单位" style="width: 100%">
                <el-option label="个" value="个" />
                <el-option label="件" value="件" />
                <el-option label="套" value="套" />
                <el-option label="千克" value="千克" />
                <el-option label="米" value="米" />
                <el-option label="平方米" value="平方米" />
              </el-select>
            </el-form-item>
          </el-col>
          
          <el-col :span="12">
            <el-form-item label="状态" prop="status">
              <el-select v-model="productForm.status" placeholder="请选择状态" style="width: 100%">
                <el-option label="启用" :value="1" />
                <el-option label="禁用" :value="0" />
                <el-option label="缺货" :value="2" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="材质" prop="material">
              <el-input v-model="productForm.material" placeholder="请输入材质" />
            </el-form-item>
          </el-col>
          
          <el-col :span="12">
            <el-form-item label="颜色" prop="color">
              <el-input v-model="productForm.color" placeholder="请输入颜色" />
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="尺寸规格" prop="size">
              <el-input v-model="productForm.size" placeholder="请输入尺寸规格" />
            </el-form-item>
          </el-col>
          
          <el-col :span="12">
            <el-form-item label="重量(kg)" prop="weight">
              <el-input-number
                v-model="productForm.weight"
                :min="0"
                :precision="2"
                :step="0.1"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-form-item label="产品图片">
          <el-upload
            class="avatar-uploader"
            action="#"
            :show-file-list="false"
            :before-upload="beforeAvatarUpload"
            :on-change="handleImageChange">
            <img v-if="productForm.image" :src="productForm.image" class="avatar" />
            <el-icon v-else class="avatar-uploader-icon"><Plus /></el-icon>
          </el-upload>
        </el-form-item>
        
        <el-form-item label="产品描述" prop="description">
          <el-input
            v-model="productForm.description"
            type="textarea"
            :rows="3"
            placeholder="请输入产品详细描述"
          />
        </el-form-item>
        
        <el-form-item label="规格参数" prop="specification">
          <el-input
            v-model="productForm.specification"
            type="textarea"
            :rows="3"
            placeholder="请输入产品规格参数"
          />
        </el-form-item>
      </el-form>
      
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="handleSubmit" :loading="submitting">
            确定
          </el-button>
        </span>
      </template>
    </el-dialog>

    <!-- 详情对话框 -->
    <el-dialog
      v-model="detailDialogVisible"
      title="产品详情"
      width="700px">
      <el-descriptions :column="2" border>
        <el-descriptions-item label="产品大类">{{ currentProduct.type }}</el-descriptions-item>
        <el-descriptions-item label="产品型号">{{ currentProduct.spa }}</el-descriptions-item>
        <el-descriptions-item label="产品名称">{{ currentProduct.name }}</el-descriptions-item>
        <el-descriptions-item label="品牌">{{ currentProduct.brand || '-' }}</el-descriptions-item>
        <el-descriptions-item label="产品分类">{{ currentProduct.category || '-' }}</el-descriptions-item>
        <el-descriptions-item label="子分类">{{ currentProduct.sub_category || '-' }}</el-descriptions-item>
        <el-descriptions-item label="计量单位">{{ currentProduct.unit || '-' }}</el-descriptions-item>
        <el-descriptions-item label="材质">{{ currentProduct.material || '-' }}</el-descriptions-item>
        <el-descriptions-item label="颜色">{{ currentProduct.color || '-' }}</el-descriptions-item>
        <el-descriptions-item label="尺寸规格">{{ currentProduct.size || '-' }}</el-descriptions-item>
        <el-descriptions-item label="重量(kg)">{{ currentProduct.weight || '-' }}</el-descriptions-item>
        <el-descriptions-item label="状态">
          <el-tag :type="getStatusType(currentProduct.status)">
            {{ getStatusText(currentProduct.status) }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="创建时间">{{ formatDate(currentProduct.created_at) }}</el-descriptions-item>
        <el-descriptions-item label="创建人">{{ currentProduct.created_by || '-' }}</el-descriptions-item>
        <el-descriptions-item label="产品描述" :span="2">
          {{ currentProduct.description || '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="规格参数" :span="2">
          {{ currentProduct.specification || '-' }}
        </el-descriptions-item>
      </el-descriptions>
      
      <template #footer>
        <el-button @click="detailDialogVisible = false">关闭</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { ElMessage, ElMessageBox } from 'element-plus'
import { Plus, Download, Picture } from '@element-plus/icons-vue'

export default {
  name: 'Product',
  components: {
    Plus,
    Download,
    Picture
  },
  data() {
    return {
      // 搜索表单
      searchForm: {
        type: '',
        spa: '',
        name: '',
        status: ''
      },
      
      // 表格数据
      tableData: [],
      loading: false,
      
      // 分页
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      
      // 对话框
      dialogVisible: false,
      detailDialogVisible: false,
      dialogTitle: '新增产品',
      submitting: false,
      editingId: null,
      
      // 当前查看的产品
      currentProduct: {},
      
      // 产品表单
      productForm: {
        type: '',
        spa: '',
        name: '',
        brand: '',
        category: '',
        sub_category: '',
        unit: '',
        material: '',
        color: '',
        size: '',
        weight: null,
        status: 1,
        description: '',
        specification: '',
        image: ''
      },
      
      // 表单验证规则
      productRules: {
        type: [
          { required: true, message: '请选择产品大类', trigger: 'change' }
        ],
        spa: [
          { required: true, message: '请输入产品型号', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入产品名称', trigger: 'blur' }
        ],
        unit: [
          { required: true, message: '请选择计量单位', trigger: 'change' }
        ],
        status: [
          { required: true, message: '请选择状态', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    productFormRef() {
      return this.$refs.productFormRef
    }
  },
  mounted() {
    this.loadTableData()
  },
  methods: {
    // 加载表格数据
    async loadTableData() {
      this.loading = true
      try {
        const params = {
          page: this.pagination.currentPage,
          limit: this.pagination.pageSize,
          ...this.searchForm
        }
        
        // 这里调用后端API
        // const response = await this.$axios.get('/api/bom/list', { params })
        // this.tableData = response.data.list || []
        // this.pagination.total = response.data.total || 0
        
        // 模拟数据
        this.tableData = [
          {
            id: 1,
            type: '电子类',
            spa: 'ELC-001',
            name: '智能手表',
            brand: '小米',
            category: '智能穿戴',
            sub_category: '手表',
            unit: '个',
            weight: 0.15,
            status: 1,
            created_at: '2025-10-28 10:00:00',
            created_by: '管理员'
          },
          {
            id: 2,
            type: '机械类',
            spa: 'MEC-001',
            name: '工业机器人',
            brand: 'ABB',
            category: '工业设备',
            sub_category: '机器人',
            unit: '台',
            weight: 150.5,
            status: 1,
            created_at: '2025-10-27 14:30:00',
            created_by: '管理员'
          }
        ]
        this.pagination.total = 2
        
      } catch (error) {
        console.error('加载产品数据失败:', error)
        ElMessage.error('加载产品数据失败')
      } finally {
        this.loading = false
      }
    },
    
    // 搜索
    handleSearch() {
      this.pagination.currentPage = 1
      this.loadTableData()
    },
    
    // 重置搜索
    handleReset() {
      this.searchForm = {
        type: '',
        spa: '',
        name: '',
        status: ''
      }
      this.pagination.currentPage = 1
      this.loadTableData()
    },
    
    // 新增产品
    handleAdd() {
      this.dialogTitle = '新增产品'
      this.editingId = null
      this.productForm = {
        type: '',
        spa: '',
        name: '',
        brand: '',
        category: '',
        sub_category: '',
        unit: '',
        material: '',
        color: '',
        size: '',
        weight: null,
        status: 1,
        description: '',
        specification: '',
        image: ''
      }
      this.dialogVisible = true
    },
    
    // 编辑产品
    handleEdit(row) {
      this.dialogTitle = '编辑产品'
      this.editingId = row.id
      this.productForm = { ...row }
      this.dialogVisible = true
    },
    
    // 查看详情
    handleView(row) {
      this.currentProduct = { ...row }
      this.detailDialogVisible = true
    },
    
    // 删除产品
    async handleDelete(id) {
      try {
        await ElMessageBox.confirm('确定要删除这个产品吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        
        // 这里调用后端API
        // await this.$axios.delete(`/api/bom/delete/${id}`)
        
        ElMessage.success('删除成功')
        this.loadTableData()
      } catch (error) {
        // 用户取消删除
      }
    },
    
    // 导出数据
    handleExport() {
      ElMessage.info('导出功能开发中...')
    },
    
    // 分页大小改变
    handleSizeChange(size) {
      this.pagination.pageSize = size
      this.loadTableData()
    },
    
    // 当前页改变
    handleCurrentChange(page) {
      this.pagination.currentPage = page
      this.loadTableData()
    },
    
    // 图片上传前检查
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2
      
      if (!isJPG && !isPNG) {
        ElMessage.error('上传图片只能是 JPG/PNG 格式!')
        return false
      }
      if (!isLt2M) {
        ElMessage.error('上传图片大小不能超过 2MB!')
        return false
      }
      return true
    },
    
    // 处理图片上传
    handleImageChange(file) {
      // 这里处理图片上传逻辑
      // 实际项目中需要调用上传接口
      const reader = new FileReader()
      reader.onload = (e) => {
        this.productForm.image = e.target.result
      }
      reader.readAsDataURL(file.raw)
    },
    
    // 表单提交
    async handleSubmit() {
      if (!this.productFormRef) return
      
      try {
        await this.productFormRef.validate()
        this.submitting = true
        
        // 这里调用后端API
        if (this.editingId) {
          // 编辑产品
          // await this.$axios.put(`/api/bom/update/${this.editingId}`, this.productForm)
          ElMessage.success('编辑成功')
        } else {
          // 新增产品
          // await this.$axios.post('/api/bom/add', this.productForm)
          ElMessage.success('新增成功')
        }
        
        this.dialogVisible = false
        this.loadTableData()
      } catch (error) {
        // 验证失败
      } finally {
        this.submitting = false
      }
    },
    
    // 对话框关闭
    handleDialogClose() {
      this.productFormRef?.resetFields()
    },
    
    // 获取状态文本
    getStatusText(status) {
      const statusMap = {
        0: '禁用',
        1: '启用',
        2: '缺货'
      }
      return statusMap[status] || '未知'
    },
    
    // 获取状态类型
    getStatusType(status) {
      const typeMap = {
        0: 'danger',
        1: 'success',
        2: 'warning'
      }
      return typeMap[status] || 'info'
    },
    
    // 格式化日期
    formatDate(dateString) {
      if (!dateString) return '-'
      return dateString
    }
  }
}
</script>

<style scoped>
.product-container {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: calc(100vh - 40px);
}

.search-section {
  margin-bottom: 20px;
}

.search-form {
  margin-bottom: 16px;
}

.action-buttons {
  display: flex;
  gap: 10px;
}

.table-section {
  margin-bottom: 20px;
}

.pagination-section {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

/* 图片上传样式 */
.avatar-uploader {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 100px;
  height: 100px;
}

.avatar-uploader:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}

.avatar {
  width: 100px;
  height: 100px;
  display: block;
  object-fit: cover;
}

/* 无图片样式 */
.no-image {
  width: 60px;
  height: 60px;
  background-color: #f5f7fa;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #c0c4cc;
}

.image-slot {
  width: 60px;
  height: 60px;
  background-color: #f5f7fa;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #c0c4cc;
}
</style>
